


























































import {mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  name: 'Tipline',
  components: {
  },
  data () {
    return {
      form: {
        'location': {value: '', touched: false, required: true,  valid: null},
        'time':     {value: '', touched: false, required: false, valid: null},
        'details':  {value: '', touched: false, required: true,  valid: null},
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentSite',
      'currentSiteRandId',
      'currentSiteName'
    ]),
    siteLogo () {
      if (this.currentSite) {
        try {
          return require(`@/assets/site-${this.currentSite['id']}.jpg`);
        } catch (error) {
          return require('@/assets/sdm-logo-sml.png');
        }
      }
      return require('@/assets/sdm-logo-sml.png');
    }
  },
  methods: {
    ...mapActions([
      'loadSiteByRandId',
      'submitToTipline'
    ]),
    validateAndSubmit () {
      console.log('validateAndSubmit', this.form)
      if (this.validateForm()) {
        this.submitToTipline(this.form)
      }
    },
    validateForm (fieldChanged: string) {
      console.log('validateForm', fieldChanged)
      let dob, allValid = true
      if (fieldChanged) {
        this.form[fieldChanged].touched = true
      } else {
        for (let field in this.form) {
          this.form[field].touched = true
        }
      }
      for (let field in this.form) {
        if (this.form[field].required) {
          if (this.form[field].touched) {
            if (this.form[field].value) {
              this.form[field].valid = true
            } else {
              this.form[field].valid = false
              allValid = false
            }
          }
        }
      }
      return allValid
    },
  },
  beforeMount () {
    console.log('Tipline.beforeMount', this.$route.params.siteRandId)
    this.loadSiteByRandId(this.$route.params.siteRandId)
  },
  mounted () {
    console.log('Tipline.mounted')
  }
}
